/**
 * @file Statistic 统计数值
 * @description 展示关键指标与可选后缀/前缀。
 *
 * @whenToUse 仪表盘 KPI、卡片数字。
 * @whenNotToUse 表格内普通数字列。
 */

import type { ReactNode } from 'react'
import { cn } from '@/lib/cn.ts'

export type StatisticProps = {
  /** 指标标题 */
  title: ReactNode
  /** 主数值 */
  value: ReactNode
  /** 前缀 */
  prefix?: ReactNode
  /** 后缀 */
  suffix?: ReactNode
  /** 说明 */
  description?: ReactNode
  className?: string
}

export function Statistic({
  title,
  value,
  prefix,
  suffix,
  description,
  className,
}: StatisticProps) {
  return (
    <div className={cn('flex flex-col gap-1', className)}>
      <div className="text-xs text-muted">{title}</div>
      <div className="flex items-baseline gap-1 text-2xl font-semibold tracking-tight text-foreground">
        {prefix ? <span className="text-base font-medium">{prefix}</span> : null}
        <span className="tabular-nums">{value}</span>
        {suffix ? (
          <span className="text-sm font-normal text-muted">{suffix}</span>
        ) : null}
      </div>
      {description ? (
        <p className="text-xs text-muted">{description}</p>
      ) : null}
    </div>
  )
}
